import { Switch, withStyles } from '@material-ui/core';

const ElegantSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 22,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(20px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 'none',
      },
    },
    '&$disabled': {
      '&$checked': {
        '& + $track': {
          backgroundColor: '#8E8E8E',
          opacity: 0.3,
        },
      },
    },
    '&$focusVisible $thumb': {
      color: theme.palette.primary.main,
      border: '4px solid #fff',
    },
  },
  thumb: {
    width: 18,
    height: 18,
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
  },
  track: {
    borderRadius: 22 / 2,
    backgroundColor: '#8E8E8E',
    opacity: 0.3,
    transition: theme.transitions.create(['background-color', 'opacity']),
  },
  checked: {},
  focusVisible: {},
  disabled: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
        disabled: classes.disabled,
      }}
      {...props}
    />
  );
});

export default ElegantSwitch;
